
import SideNavSecondary from '@library/components/Molecules/Header/SideNavSecondary.vue'
export default {
  name: 'SubMenuItem',
  components: {SideNavSecondary},
  data: () => ({}),
  props: {
    title: {
      type: String,
      default: ''
    },
    navigationList: {
      type: Object,
      required: true
    },
    navigationColum: {
      type: Array,
      required: true,
      default: () => []
    },
    activeMenu: {
      type: Boolean,
      default: false
    },
    isOpenSubMenuItem: {
      type: Boolean,
      default: false
    }
  }
}
